import React, { useEffect, useState } from "react";
import { useProfileContext } from "../context/ProfileContext";
import { useAuthContext } from "../context/AuthContext";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";

// Imports
import DashboardWrapper from "../components/DashboardWrapper";
import { MdArrowBackIos } from "../utils/Icons";
import CustomSelect from "../components/CustomComponents/CustomSelect";

const MyProfile = () => {
  const navigate = useNavigate();
  const [editProfile, setEditProfile] = useState(false);
  const { userProfile, setUserProfile, userProfileSave, getUserProfile } =
    useProfileContext();

    const {
      handleUserLogout,
      handleTC,
      handleTCPP,
      deleteUser
    } = useAuthContext();

  const handleUserProfileChange = (e) => {
    const { name, value } = e.target;
    setUserProfile((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleGenderSelect = (gender) => {
    setUserProfile((prevState) => ({
      ...prevState,
      gender,
    }));
  };

  useEffect(() => {
    const token = Cookies.get("token");
    const userId = Cookies.get("userId");

    if (token && userId) {
      getUserProfile();
    }
  }, []);


  const [deletePopup, setDeletePopup] = useState(false);

  return (
    <DashboardWrapper>
      {/** Large Screens */}
      <div className="w-full h-fit space-y-[3%] hidden lg:block">
        {deletePopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white rounded-[40px] w-[30%] h-[40%] p-[2%] shadow-lg flex flex-col justify-between">
          
          <p className="text-center text-[1.2vw] font-semibold">
            Are you sure you want to<br />delete your profile?
          </p>

          <p className="text-center text-[0.8vw]">
            This action is permanent and cannot be undone. All<br />
            your data will be removed from our system.
          </p>

          <div className="w-full flex justify-center space-x-[5%] items-center">
            <button className="text-[#0047AF] border border-[#0047AF] rounded-[20px] py-[4%] rounded-full w-full text-[4vw] lg:text-[1vw]" onClick={()=>setDeletePopup(false)}>
              Cancel
            </button>
            <button className="bg-[#FF3B30] text-white rounded-[20px] rounded-full w-full py-[4%] text-[4vw] lg:text-[1vw]" onClick={deleteUser}>
              Delete Account
            </button>
          </div>

        </div>
      </div>
        )}
        <div className="w-full h-fit flex justify-between items-center space-x-[5%]">
          <div className="w-full h-fit flex flex-col space-y-[2%]">
            <label
              htmlFor="name"
              className="font-normal text-[1vw] text-textSecondaryColor"
            >
              Name
            </label>
            <input
              type="text"
              id="name"
              name="name"
              placeholder="Full Name"
              value={userProfile?.name}
              onChange={handleUserProfileChange}
              maxLength={25}
              className="input-primary"
            />
          </div>
          <div className="w-full h-fit flex flex-col space-y-[2%]">
            <label
              htmlFor="dob"
              className="font-normal text-[1vw] text-textSecondaryColor"
            >
              Date of Birth
            </label>
            <input
              type="date"
              id="dob"
              name="dob"
              value={userProfile?.dob}
              onChange={handleUserProfileChange}
              max={new Date().toISOString().split("T")[0]}
              className="input-primary"
            />
          </div>
        </div>
        <div className="w-full h-fit flex justify-between items-center space-x-[5%]">
          <div className="w-full h-fit flex flex-col space-y-[2%]">
            <label
              htmlFor="contact"
              className="font-normal text-[1vw] text-textSecondaryColor"
            >
              Contact Number
            </label>
            <input
              type="number"
              id="contact"
              name="contact"
              placeholder="Contact Number"
              value={userProfile?.contact}
              onChange={(e) => {
                const value = e.target.value;
                if (value.length <= 10) {
                  handleUserProfileChange(e);
                }
              }}
              onKeyDown={(e)=>{
                if(['e', '+','-', '.', ','].includes(e.key)){
                  e.preventDefault();
                }
              }}
              max={9999999999}
              className="input-primary"
            />
          </div>
          <div className="w-full h-fit flex flex-col space-y-[2%]">
            <span className="font-normal text-[1vw] text-textSecondaryColor">
              Email
            </span>
            <p className="w-full bg-gray-300 border-2 rounded-2xl px-[4%] py-[3%] font-normal text-[1vw] text-textSecondaryColor">
              {userProfile?.email}
            </p>
          </div>
        </div>
        <CustomSelect
          dataArray={["male", "female", "other"]}
          onSelect={handleGenderSelect}
          selectedItem={userProfile?.gender}
        />
        <div className="flex justify-between items-center"  style={{ marginTop: "5%" }}>
        {userProfile?.name?.length > 0 &&
        userProfile?.dob?.length > 0 &&
        userProfile?.contact?.toString().length === 10 &&
        userProfile?.email?.length > 0 &&
        userProfile?.gender?.length > 0 ? (
          <button
            className="btn-primary"
            onClick={userProfileSave}
          >
            Save
          </button>
        ) : (
          <button
            disabled={true}
            className="btn-secondary"
          >
            Save
          </button>
        )}
          <button className="border-[2px] border-[#FF3B30] text-[#FF3B30] rounded-full px-[4.5%] py-[3.5%] lg:py-[1.5%] font-normal text-[4vw] lg:text-[1vw]" onClick={()=>setDeletePopup(true)}>
            Delete Account
          </button>

        </div>
      </div>

      {/** Small Screens */}
      {editProfile ?(
        <div className="w-full h-fit space-y-[3%] lg:hidden">
          {deletePopup && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-[40px] w-[90%] h-[35%] p-[3%] shadow-lg flex flex-col justify-between">
              
              <p className="text-center text-[5vw] font-semibold">
                Are you sure you want to<br />delete your profile?
              </p>

              <p className="text-center text-[3.5vw]">
                This action is permanent and cannot be undone. All
                your data will be removed from our system.
              </p>

              <div className="w-full flex justify-center space-x-[5%] items-center mb-2">
                <button className="text-[#0047AF] border border-[#0047AF] rounded-full  py-[4%] rounded-full w-full text-[4vw] lg:text-[1vw]" onClick={()=>setDeletePopup(false)}>
                  Cancel
                </button>
                <button className="bg-[#FF3B30] text-white rounded-full w-full py-[4%] text-[4vw] lg:text-[1vw] " onClick={deleteUser}>
                  Delete Account
                </button>
              </div>

            </div>
          </div>
            )}
            <button
                className="flex items-center font-normal  mb-2 text-[4vw] lg:text-[1vw] text-textPrimaryColor"
                onClick={() => setEditProfile(false)}
              >
                <MdArrowBackIos className="text-[5vw] lg:text-[1.5vw]" />
                <span>Back</span>
              </button>
        {/** <div className="w-full h-fit flex flex-col space-y-[2%]">
            <label
              htmlFor="name"
              className="font-normal text-[1vw] text-textSecondaryColor"
            >
              Name
            </label>
            <input
              type="text"
              id="name"
              name="name"
              placeholder="Full Name"
              value={userProfile?.name}
              onChange={handleUserProfileChange}
              maxLength={25}
              className="input-primary"
            />
          </div> */}
        <div className="w-full h-fit flex flex-col space-y-[2%]">
          <span className="font-normal text-[4vw] text-textSecondaryColor">
            Name
          </span>
          <p className="w-full bg-gray-300 border-2 rounded-xl px-[4%] py-[3%] font-normal text-[4vw] text-textSecondaryColor">
            {userProfile?.name}
          </p>
        </div>
        <div className="w-full h-fit flex flex-col space-y-[2%]">
          <label
            htmlFor="dob"
            className="font-normal text-[4vw] text-textSecondaryColor"
          >
            Date of Birth
          </label>
          <input
            type="date"
            id="dob"
            name="dob"
            value={userProfile?.dob}
            onChange={handleUserProfileChange}
            max={new Date().toISOString().split("T")[0]}
            className="input-primary"
          />
        </div>
        <div className="w-full h-fit flex flex-col space-y-[2%]">
          <label
            htmlFor="contact"
            className="font-normal text-[4vw] text-textSecondaryColor"
          >
            Contact Number
          </label>
          <input
            type="number"
            id="contact"
            name="contact"
            placeholder="Contact Number"
            value={userProfile?.contact}
            onChange={(e) => {
              const value = e.target.value;
              if (value.length <= 13) {
                handleUserProfileChange(e);
              }
            }}
            max={9999999999999}
            className="input-primary"
          />
        </div>
        <div className="w-full h-fit flex flex-col space-y-[2%]">
          <span className="font-normal text-[4vw] text-textSecondaryColor">
            Email
          </span>
          <p className="w-full bg-gray-300 border-2 rounded-xl px-[4%] py-[3%] font-normal text-[4vw] text-textSecondaryColor">
            {userProfile?.email}
          </p>
        </div>
        <CustomSelect
          dataArray={["male", "female", "other"]}
          onSelect={handleGenderSelect}
          selectedItem={userProfile?.gender}
        />
        <button
          className="btn-primary"
          onClick={userProfileSave}
          style={{ marginTop: "5%",width:"100%",height:56, marginBottom:"4%" }}
        >
        Update Profile
        </button>
        <div className="flex justify-center">
        <button
        className="border-[2px] border-[#FF3B30] text-[#FF3B30] rounded-full w-1/2 h-[56px] font-normal text-[4vw] lg:text-[1vw]" 
        onClick={()=>setDeletePopup(true)}
        >
          Delete Account
        </button>
        </div>
      </div>
      ):(
        <div className="w-full h-fit space-y-[3%] block lg:hidden">
        <div className="flex flex-row items-center mb-[10%] justify-between">
          <div className="flex flex-row items-center space-x-3">
            <div>
              <img src="/assets/phone-profile-icon.svg" alt=""/>
            </div>
            <div>
              <span className="text-black text-[17.09px]">{userProfile?.name}</span> <br/>
              <span className="text-[#57636C] text-[11.97px]">{userProfile?.email}</span>
            </div>
          </div>
          <div onClick={()=>{setEditProfile(true)}}>
            <img src="/assets/edit-profile-icon.svg" alt=""/>
          </div>
        </div>
        <div className="w-full h-fit flex flex-col space-y-[10%]">
         <div className="flex flex-col space-y-[3%]">
         <h1 className="text-[14px] text-[#57636C]">Accounts</h1>
          <div className="h-[56px] pl-2 pr-2 border rounded-[16px] border-[#E0E0E0] flex flex-row space-x-[2%] justify-between items-center" onClick={()=>{navigate("/my-order")}}>
            <div className="w-full flex items-center space-x-[3%]">
            <div>
              <img src="/assets/myOrders-profile-icon.svg" alt=""/>
              </div>
              <div>
                My Orders
              </div>
            </div>
            <div>
              <img src="/assets/arrow-profile-icon.svg" alt=""/>
            </div>
          </div>
          <div className="h-[56px] pl-2 pr-2 border rounded-[16px] border-[#E0E0E0] flex flex-row space-x-[2%] justify-between items-center" onClick={()=>{navigate("/family-member")}}>
            <div className="w-full flex items-center space-x-[3%]">
            <div>
              <img src="/assets/family-profile-icon.svg" alt=""/>
              </div>
              <div>
                Family Members
              </div>
            </div>
            <div>
              <img src="/assets/arrow-profile-icon.svg" alt=""/>
            </div>
          </div>
          <div className="h-[56px] pl-2 pr-2 border rounded-[16px] border-[#E0E0E0] flex flex-row space-x-[2%] justify-between items-center" onClick={()=>{navigate("/my-address")}}>
            <div className="w-full flex items-center space-x-[3%]">
            <div>
              <img src="/assets/address-profile-icon.svg" alt=""/>
              </div>
              <div>
                My Address
              </div>
            </div>
            <div>
              <img src="/assets/arrow-profile-icon.svg" alt=""/>
            </div>
          </div>
         </div>
         <div className="flex flex-col space-y-[3%]">
         <h1 className="text-[14px] text-[#57636C]">General</h1>
          <div className="h-[56px] pl-2 pr-2 border rounded-[16px] border-[#E0E0E0] flex flex-row space-x-[2%] justify-between items-center" onClick={()=>{navigate("/support")}}>
            <div className="w-full flex items-center space-x-[3%]">
            <div>
              <img src="/assets/support-profile-icon.svg" alt=""/>
              </div>
              <div>
                Support
              </div>
            </div>
            <div>
              <img src="/assets/arrow-profile-icon.svg" alt=""/>
            </div>
          </div>
          <div className="h-[56px] pl-2 pr-2 border rounded-[16px] border-[#E0E0E0] flex flex-row space-x-[2%] justify-between items-center" onClick={handleTCPP}>
            <div className="w-full flex items-center space-x-[3%]">
            <div>
              <img src="/assets/privacy-policy-profile-icon.svg" alt=""/>
              </div>
              <div>
                Privacy Policy
              </div>
            </div>
            <div>
              <img src="/assets/arrow-profile-icon.svg" alt=""/>
            </div>
          </div>
          <div className="h-[56px] pl-2 pr-2 border rounded-[16px] border-[#E0E0E0] flex flex-row space-x-[2%] justify-between items-center" onClick={handleTC}>
            <div className="w-full flex items-center space-x-[3%]">
            <div>
              <img src="/assets/terms-condition-profile-icon.svg" alt=""/>
              </div>
              <div>
                Terms & Conditions
              </div>
            </div>
            <div>
              <img src="/assets/arrow-profile-icon.svg" alt=""/>
            </div>
          </div>
          <div className="h-[56px] pl-2 pr-2 border rounded-[16px] border-[#E0E0E0] flex flex-row space-x-[2%] justify-between items-center" onClick={handleUserLogout}>
            <div className="w-full flex items-center space-x-[3%]">
            <div>
              <img src="/assets/logout-profile-icon.svg" alt=""/>
              </div>
              <div>
                Logout
              </div>
            </div>
            <div>
              <img src="/assets/arrow-profile-icon.svg" alt=""/>
            </div>
          </div>
         </div>
        </div>
      </div>
      )}
     
    </DashboardWrapper>
  );
};

export default MyProfile;
